import {IconButton} from '@wandb/components';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import {AgentIcon} from './icons';

const BETA_TOOLTIP_TEXT = [
  'Internal only: available to W&B employees in wandb org projects.',
  'Under active development: features and behavior may change rapidly.',
  'Chat history may be deleted at any time.',
  'This agent can modify your data - use with care.',
  'Chat logs are reviewed during beta - avoid sharing sensitive information.',
  'Please report feedback to the #wbagent channel in the W&B Slack.',
].join('\n');

export const ChatHeader: React.FC<{
  available: boolean | null;
  popped: boolean;
  onDragStart?: (e: React.MouseEvent) => void;
  onPopOut: () => void;
  onDockBack: () => void;
  onClose: () => void;
}> = ({available, popped, onDragStart, onPopOut, onDockBack, onClose}) => (
  <div
    onMouseDown={popped ? onDragStart : undefined}
    className={`flex h-40 min-h-[40px] items-center justify-between border-b border-[#E8E8E9] bg-white px-10 ${
      popped ? 'cursor-grab rounded-t-[12px] active:cursor-grabbing' : ''
    }`}>
    <div className="flex items-center gap-4">
      <div className="flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded bg-[#038194] text-white">
        <AgentIcon />
      </div>
      <span className="text-[13px] font-semibold tracking-[-0.01em] text-[#2B3038]">
        WB Agent
      </span>
      <Tooltip
        position="bottom center"
        trigger={
          <span className="cursor-help rounded-[3px] bg-[#FFF3CD] px-[5px] py-px text-[10px] font-semibold leading-[1.4] text-[#856404]">
            Internal Beta
          </span>
        }>
        <span className="whitespace-pre-line">{BETA_TOOLTIP_TEXT}</span>
      </Tooltip>
      {available === false && (
        <span className="rounded-[3px] bg-[#fef2f2] px-[5px] py-px text-[10px] font-semibold leading-[1.4] text-[#FF596D]">
          Unavailable
        </span>
      )}
    </div>
    <div className="flex items-center">
      <IconButton
        size="sm"
        variant="ghost"
        onPress={popped ? onDockBack : onPopOut}
        icon={popped ? 'panel' : 'open-new-tab'}
        aria-label={popped ? 'Dock to sidebar' : 'Pop out'}
      />
      <IconButton
        size="sm"
        variant="ghost"
        onPress={onClose}
        icon="close"
        aria-label="Close"
      />
    </div>
  </div>
);
